import React from "react";
import { classnames } from "../../utils/text";
import Icon from "../Icon";

const IconButton = ({
  disabled = false,
  action,
  onClick,
  icon,
  className,
  iconClassName,
  labelClassName,
  label,
}) => {
  const _action = () => {
    if (action) return action;
    if (onClick) return onClick;
    return () => {};
  };

  return (
    <button
      className={classnames("icon-button", className)}
      type="button"
      onClick={_action()}
      disabled={disabled}
    >
      <Icon src={icon} className={iconClassName} />
      {label && <label className={labelClassName}>{label}</label>}
    </button>
  );
};

export default IconButton;
